// --------------------------------------------------------------
// Created On: 2024-04-02
// Author: Hannah Vaughan
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import PumpLink from "./PumpLink/PumpLink";
import { MANUAL_URL, PUMP_CURVES_URL, EXPLODED_DRAWING_URL, VIDEOS_URL } from "../../../constants/urls";

// Component containing a set of PumpLink components for links to the pump's manual(s), curves and additional drawings,
// assembly/maintenance videos, and exploded drawing on the Scan QR Code page.
export default function PumpLinks(props: Props): Component {
  const manual1Description = `O&M Manual ${props.manual1Name}`;
  const manual1Url = `${MANUAL_URL}/manual/getManual?man=${props.manual1Name}`;
  const manual2Description = `O&M Manual ${props.manual2Name}`;
  const manual2Url = `${MANUAL_URL}/manual/getManual?man=${props.manual2Name}`;
  const pumpCurvesUrl = `${PUMP_CURVES_URL}/#/pump/${props.pumpType}`;
  const explodedDrawingUrl = `${EXPLODED_DRAWING_URL}/explodedview/getDrawingNum?num=${props.explodedDrawingNumber}`;
  const videosUrl = `${VIDEOS_URL}/user/cornellpump?feature=mhsn`;

  return (
    <div className="row align-items-center h-100">
      <PumpLink
        iconClass="fa fa-fw fa-2x fa-file-pdf-o"
        marginClass="mt-3 mb-2"
        description={manual1Description}
        url={manual1Url}
      />
      {props.manual2Name !== null && props.manual2Name !== "" && (
        <PumpLink
          iconClass="fa fa-fw fa-2x fa-file-pdf-o"
          marginClass="mt-3 mb-2"
          description={manual2Description}
          url={manual2Url}
        />
      )}
      <PumpLink
        iconClass="fa fa-fw fa-2x fa-picture-o"
        marginClass="my-1"
        description="Pump Curves & Additional Drawings"
        url={pumpCurvesUrl}
      />
      <PumpLink
        iconClass="fa fa-fw fa-2x fa-youtube-play mt-1"
        marginClass="mt-1"
        description="Assembly / Maintenance Videos"
        url={videosUrl}
      />
      {props.explodedDrawingNumber !== null && props.explodedDrawingNumber !== "" && (
        <PumpLink
          iconClass="fa fa-fw fa-2x fa-search-plus mt-2"
          marginClass="mb-2"
          description="View Exploded Drawing"
          url={explodedDrawingUrl}
        />
      )}
    </div>
  );
}

interface Props {
  loading: boolean;
  manual1Name: string;
  manual2Name: string | null;
  serialNumber: string;
  bomNumber: string;
  pumpType: string;
  explodedDrawingNumber: string | null;
}
